// extracted by mini-css-extract-plugin
export default {"rotate":"SpinIcon_rotate__sCsI3","rotation":"SpinIcon_rotation__nF-nf","limited-cell":"SpinIcon_limited-cell__ka+JB"};